import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  useMediaQuery,
  Tabs,
  Paper,
  Tab,
  Box,
  Chip,
} from "@mui/material";

import UploadIcon from "@mui/icons-material/Upload";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HomeIcon from "@mui/icons-material/Home";
import SchoolIcon from "@mui/icons-material/School";
import BadgeIcon from "@mui/icons-material/Badge";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import DateRangeIcon from "@mui/icons-material/DateRange";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";

function BasicInfo({ candidateData }) {
  return (
    <Grid container spacing={3}>
      {/* Personal Information */}
      <Grid item xs={12} sm={12} md={6}>
        <Card
          variant="outlined"
          sx={{
            borderRadius: "10px",
            minHeight: "440px",
            border: "1px solid #006CB880",
          }}
        >
          <CardContent>
            <Typography
              sx={{
                fontFamily: "Geist, sans-serif",
                letterSpacing: `0.5px`,
                fontSize: "24px",
                color: "#333",
                fontWeight: "600",
              }}
              mb={2}
            >
              Personal Information
            </Typography>
            <Grid container spacing={2} p={2}>
              {[
                {
                  label: "Full Name",
                  value: candidateData.CI_Name,
                  icon: <PersonOutlineIcon />,
                },
                // {
                //   label: "Alias",
                //   value: candidateData.CI_Alias,
                //   icon: <AlternateEmailIcon />,
                // },
                {
                  label: "Email Address",
                  value: candidateData.CI_PrimaryEmail,
                  icon: <EmailIcon />,
                },
                {
                  label: "Secondary Email",
                  value: candidateData.CI_SecondaryEmail,
                  icon: <EmailIcon />,
                },
                {
                  label: "Mobile Number",
                  value: candidateData.CI_PrimaryMobile,
                  icon: <PhoneIphoneIcon />,
                },
                {
                  label: "Emergency Contact",
                  value: candidateData.CI_EmergencyMobile,
                  icon: <PhoneIphoneIcon />,
                },
                {
                  label: "Date of Birth",
                  value: candidateData.CI_Dateofbirth,
                  icon: <CalendarTodayIcon />,
                },
                {
                  label: "Age",
                  value: candidateData.CI_Age,
                  icon: <CalendarTodayIcon />,
                },
                {
                  label: "Address",
                  value: candidateData.CI_Address,
                  icon: <HomeIcon />,
                },
                {
                  label: "Passport Number",
                  value: candidateData.CI_PassportNo,
                  icon: <BadgeIcon />,
                },
              ].map((item, i) => (
                <Grid item xs={12} sm={6} md={12} lg={12} xl={6} key={i}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2} mt={0.5} color="#71717a">
                      {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: 500,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: 400,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.value || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Professional Information */}
      <Grid item xs={12} sm={12} md={6}>
        <Card
          variant="outlined"
          sx={{
            borderRadius: "10px",
            minHeight: "440px",
            border: "1px solid #006CB880",
          }}
        >
          <CardContent>
            <Typography
              sx={{
                fontFamily: "Geist, sans-serif",
                letterSpacing: `0.5px`,
                fontSize: "24px",
                color: "#333",
                fontWeight: "600",
              }}
              mb={2}
            >
              Professional Information
            </Typography>
            <Grid container spacing={2} p={2}>
              {[
                {
                  label: "Profession",
                  value: candidateData.CI_Profession,
                  icon: <WorkOutlineIcon />,
                },
                {
                  label: "Designation",
                  value: candidateData.CI_Designation,
                  icon: <WorkOutlineIcon />,
                },
                {
                  label: "Experience",
                  value: candidateData.CI_YearofExp,
                  icon: <AccessTimeIcon />,
                },
                {
                  label: "Last Working Date",
                  value: candidateData.CI_Last_working_date,
                  icon: <CalendarTodayIcon />,
                },
                {
                  label: "Registration / License",
                  value: candidateData.CI_Registration_License,
                  icon: <AssignmentIndIcon />,
                },
                {
                  label: "License Expiry",
                  value: candidateData.CI_Registration_License_expry,
                  icon: <DateRangeIcon />,
                },
                {
                  label: "Career Gap",
                  value: candidateData.CI_CareerGapDetl,
                  icon: <PauseCircleOutlineIcon />,
                },
              ].map((item, i) => (
                <Grid item xs={12} sm={6} md={12} lg={12} xl={6} key={i}>
                  <Box display="flex" alignItems="flex-start">
                    <Box mr={2} mt={0.5} color="#71717a">
                      {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          fontSize: "14px",
                          color: "#71717a",
                          fontWeight: 500,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          fontSize: "16px",
                          color: "#09090B",
                          fontWeight: 400,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.value || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default BasicInfo;
